module.exports = __webpack_public_path__ + "img/bul_html_component.ce251050.svg";